import { render, staticRenderFns } from "./BlwSvg.vue?vue&type=template&id=b571a0a6&"
import script from "./BlwSvg.vue?vue&type=script&lang=js&"
export * from "./BlwSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports